// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./locales/en/translation.json";
import translationES from "./locales/es/translation.json";

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
};
const originalSetItem = localStorage.setItem;


localStorage.setItem = function (key, value) {
if (key === "i18nextLng") {
console.trace("🔥 i18nextLng overwritten:", value);
}
originalSetItem.apply(this, arguments);
};
// 🔎 LOG what exists BEFORE init
console.log("🌍 i18n init start");
console.log("👉 localStorage.i18nextLng =", localStorage.getItem("i18nextLng"));
console.log("👉 navigator.language =", navigator.language);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: true, // 🔥 VERY IMPORTANT

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },

    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    // 🔎 LOG what i18next finally decided
    console.log("✅ i18n initialized");
    console.log("👉 i18n.language =", i18n.language);
    console.log("👉 localStorage.i18nextLng (after init) =", localStorage.getItem("i18nextLng"));
  });

// 🔎 LOG any runtime language change
i18n.on("languageChanged", (lng) => {
  console.log("🔁 languageChanged event:", lng);
  console.log("👉 localStorage.i18nextLng =", localStorage.getItem("i18nextLng"));
});

export default i18n;




// // src/i18n.js
// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

// import translationEN from './locales/en/translation.json';
// import translationES from './locales/es/translation.json'; // ✅ fixed naming

// const resources = {
//   en: { translation: translationEN },
//   es: { translation: translationES },
// };

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     resources,
//     fallbackLng: 'en', // use English if no suitable language found
//     debug: false, // change to true to see language detection logs

//     // detection: {
//     //   // ✅ detect language from browser
//     //   order: ['navigator', 'htmlTag', 'path', 'subdomain'],
//     //   caches: ['localStorage'], // remember user’s choice
//     // },
//     detection: {
// order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
// caches: ['localStorage'],
// },

//     interpolation: {
//       escapeValue: false, // react already protects from XSS
//     },
//   });

// export default i18n;



